import { connect } from 'react-redux'
import requestAddNote from '../../sagas/requestAddNote'
import requestAddChecklist from '../../sagas/requestAddChecklist'
import requestAddDocumentList from '../../sagas/requestAddDocumentList'
import requestAddDocumentFolder from '../../sagas/requestAddDocumentFolder'
import requestAddDocumentFolderCreator from '../../sagas/requestAddDocumentFolderCreator'
import requestAddSubCardGroup from '../../sagas/requestAddSubCardGroup'
import requestAddDocumentToCard from '../../sagas/requestAddDocumentToCard'
import requestAddDocumentFromTemplate from '../../sagas/requestAddDocumentFromTemplate'
import addElementSelector from './addElementSelector'
import AddElement from './AddElement'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  addElementSelector,
  {
    requestAddNote,
    requestAddChecklist,
    requestAddDocumentList,
    requestAddDocumentFolder,
    requestAddDocumentFolderCreator,
    requestAddSubCardGroup,
    requestAddDocumentToCard,
    requestAddDocumentFromTemplate,
  }
)(AddElement))
